const prefix = 'users-page';

export const i18n = {
    account: {
        id: `${prefix}.account`,
        defaultMessage: 'Account',
    },
    customer: {
        id: `${prefix}.customer`,
        defaultMessage: 'Customer',
    },
    noUsersMessage: {
        id: `${prefix}.noUsersMessage`,
        defaultMessage: 'There are no users to display.',
    },
} as const;
